import { addErrorDataAttribute } from 'app/components/ui/ErrorFormScrollHandler'
import { FormFeedback } from 'app/components/ui/FormFeedback'
import { Label } from 'app/components/ui/Label'
import { RadioGroup, RadioGroupProps } from 'app/components/ui/RadioGroup'
import React from 'react'
import { Controller, get, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

export type SmartRadioGroupProps = {
  name: string
  label?: string
  labelColor?: string
  errorTextColor?: string
  labelRequired?: boolean
  className?: string
} & Omit<RadioGroupProps, 'onValueChanged' | 'selectedValue'>

export const SmartRadioGroup = ({
  name,
  label,
  labelColor,
  errorTextColor,
  labelRequired,
  className,
  ...rest
}: WithChildren<SmartRadioGroupProps>): JSX.Element => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const error = get(errors, name)

  return (
    <div className={className}>
      {label && (
        <Label color={labelColor}>
          {label} {labelRequired ? <RequiredSpan> * </RequiredSpan> : null}
        </Label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value, ref } }) => (
          <RadioGroup
            onChange={onChange}
            selectedValue={value}
            ref={ref}
            {...addErrorDataAttribute(!!error)}
            {...rest}
          />
        )}
      />
      {error ? (
        <FormFeedback customColor={errorTextColor} variant='error'>
          {error.message}
        </FormFeedback>
      ) : null}
    </div>
  )
}

const RequiredSpan = styled.span`
  color: ${({ theme }) => theme.color.secondari.arancioneScuro};
`
